<template>
  <div>
    <v-sheet class="py-4 py-md-6" color="primary">
      <TitleWidget dark>{{ title }}</TitleWidget>
    </v-sheet>

    <v-container>
      <template v-if="!loading">
        <template v-if="items.length">
          <v-row class="mt-6 mb-0" justify="center">
            <v-col
              v-for="(item, keyItems) in items"
              :key="keyItems"
              cols="12"
              sm="5"
              md="4"
            >
              <DifferentialCard v-bind="item" />
            </v-col>
          </v-row>
        </template>

        <section v-else>
          <v-alert type="info"
            >Nenhum conteúdo adicionado até o momento.</v-alert
          >
        </section>
      </template>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import DifferentialCard from "../components/cards/DifferentialCard.vue";

const _config = {
  mod: "differentials",
};

const _data = {
  title: "Nossos Diferenciais",
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    DifferentialCard,
  },
};
</script>
